import type { FC } from 'react';

import { InputTitle } from 'components/input/InputTitle';
import { Row, TabItemType, Tabs, Typography } from 'enable-ui';

import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';
import { AvatarContainer } from 'modules/trainers/styles/form';

import { CustomTabs } from '../styles/tab';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';
import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

import type { LessonAndAssessmentResult } from '../core/type';

export const LearnerScoreLayout: FC<{
  tabs: TabItemType[];
  activeKey: string;
  onTabClick: (key: string) => void;
  goBack: () => void;
  data: LessonAndAssessmentResult;
}> = ({ tabs, activeKey, onTabClick, goBack, data }) => {
  const styleCard = {
    border: `1px solid #00000040`,
    padding: '16px 24px 12px 24px',
    borderRadius: 12,
    marginRight: 16,
  };

  return (
    <div style={{ width: 'calc(100% - 156px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <HeaderDetailPage title={data?.class?.name} goBack={goBack} style={{ marginBottom: 0 }} />
        <span style={{ color: '#808080' }}>&#8226; </span>
        <Typography variant="body-1" style={{ fontSize: 16, lineHeight: '22px', color: '#808080' }}>
          {data?.class?.code}
        </Typography>
        <span style={{ color: '#808080' }}>&#8226; </span>
        <Typography variant="body-1" style={{ fontSize: 16, lineHeight: '22px', color: '#808080' }}>
          {data?.class?.totalLearner} clients
        </Typography>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <AvatarContainer style={{ width: 52 }}>
          <AvatarIcon style={{ height: 52, width: 52 }} />
        </AvatarContainer>
        <Typography variant="h4" weight={500} style={{ fontSize: 26, lineHeight: '36px' }}>
          {data?.learner?.name}
        </Typography>
      </div>

      <Row style={{ margin: '16px 0' }}>
        <Row
          direction="column"
          style={{
            ...styleCard,
          }}
        >
          <InputTitle title="Leaderboard position" />
          <Typography
            variant="h4"
            weight={500}
            style={{ fontSize: 22, lineHeight: '30px', color: '#222222' }}
          >
            {0}
          </Typography>
        </Row>
        {[
          {
            title: 'Total score',
            value: Number(data?.lessonScore) + Number(data?.assessmentScore),
          },
          { title: 'Lesson score', value: Number(data?.lessonScore) },
          { title: 'Assessment score', value: Number(data?.assessmentScore) },
        ].map((item, index) => (
          <Row
            direction="column"
            style={{
              ...styleCard,
              marginRight: index === 2 ? 0 : 16,
            }}
            key={index}
          >
            <InputTitle title={item.title} />
            <Row align="center">
              <Typography
                variant="h3"
                weight={500}
                style={{ fontSize: 22, lineHeight: '30px', color: '#222222' }}
              >
                {item.value}
              </Typography>
              <StarIcon style={{ marginLeft: 4 }} />
            </Row>
          </Row>
        ))}
      </Row>
      <CustomTabs>
        <Tabs
          items={tabs}
          onTabClick={onTabClick}
          activeKey={activeKey}
          tabItemStyle={{
            height: 52,
            background: 'transparent',
            display: 'flex',
            justifyContent: 'center',
          }}
          isLine={true}
        />
      </CustomTabs>
    </div>
  );
};
